export const iconFontAwesomeDesignPenFancy = (
	<i className="fa-solid fa-pen-fancy"></i>
);
